import { render, staticRenderFns } from "./ShippingScan.vue?vue&type=template&id=7516efe1&scoped=true&"
import script from "./ShippingScan.vue?vue&type=script&lang=js&"
export * from "./ShippingScan.vue?vue&type=script&lang=js&"
import style0 from "./ShippingScan.vue?vue&type=style&index=0&id=7516efe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516efe1",
  null
  
)

export default component.exports